import type { HeartRateEvent } from '@model/DeviceConfiguration';
import {
  computeEventsSegmentPsd,
  type SegmentPsdResult,
} from './computeEventsSegmentPsd';

const spectraPsdCache = new Map<string, SegmentPsdResult>();

export const buildSpectraPsdCacheKey = (
  sessionId: number,
  startSecond: number,
  endSecond: number,
  eventCount: number
) => `${sessionId}:${startSecond}:${endSecond}:${eventCount}`;

export const getCachedSegmentPsd = (
  sessionId: number,
  startSecond: number,
  endSecond: number,
  events: HeartRateEvent[]
): SegmentPsdResult => {
  const key = buildSpectraPsdCacheKey(
    sessionId,
    startSecond,
    endSecond,
    events.length
  );
  const cached = spectraPsdCache.get(key);
  if (cached) return cached;

  const result = computeEventsSegmentPsd(events);
  spectraPsdCache.set(key, result);
  return result;
};

export const isSegmentPsdCached = (
  sessionId: number,
  startSecond: number,
  endSecond: number,
  eventCount: number
) =>
  spectraPsdCache.has(
    buildSpectraPsdCacheKey(sessionId, startSecond, endSecond, eventCount)
  );

export const clearSpectraPsdCache = () => {
  spectraPsdCache.clear();
};
